import React, { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import SSOHandler from "../Auth/SSOHandler";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";

const LayoutRoutes = lazy(() => import("../Route/LayoutRoutes"));
const Signin = lazy(() => import("../Auth/Signin"));

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("currentPharmacyPOS")));
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === "horizontal-wrapper");
  // Keep layout key resolution (used by theme/customizer localStorage).
  // eslint-disable-next-line no-unused-vars
  const layout = localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  useEffect(() => {
    let abortController = new AbortController();
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <SSOHandler />
      <Routes>
        <Route path={"/"} element={<PrivateRoute />}>
          {login ? (
            <>
              <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
              <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
            </>
          ) : (
            ""
          )}
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
        <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Signin />} />
        {authRoutes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}
      </Routes>
    </Suspense>
  );
};

export default Routers;
